import { DateTime, Duration } from 'luxon';

/**
 * Formats the duration of a call into a display string (e.g. "1h 30m", "5m 20s")
 * Returns an empty string for unanswered or missed inbound calls
 */
export const formatDuration = (
  answeredAt: string,
  endedAt: string,
  direction: string,
  disposition: string
): string => {
  if (!answeredAt || (direction === 'inbound' && disposition === 'missed')) {
    return '';
  }

  const durationInMilis =
    DateTime.fromISO(endedAt).valueOf() - DateTime.fromISO(answeredAt).valueOf();
  const [h, m, s] = Duration.fromMillis(durationInMilis)
    .toFormat('h:m:s')
    .split(':')
    .map(Number);

  if (!h) {
    const parts = [m && `${m}m`, s && `${s}s`].filter(Boolean).join(' ');
    return parts ? `(${parts})` : '';
  }

  let hours = h;
  let minutes = m;

  if (s <= 30) {
    minutes++;
  }

  if (minutes === 60) {
    hours++;
    minutes = 0;
  }

  const parts = [`${hours}h`, minutes && `${minutes}m`].filter(Boolean).join(' ');
  return `(${parts})`;
};

/**
 * Formats a start time into a display string with an uppercase AM/PM indicator (e.g. "6:30 PM")
 * Avoids showing a duplicate AM/PM if it's already part of the formatted time
 */
export const formatStartTime = (startedAt: string): string => {
  const date = DateTime.fromISO(startedAt);
  const meridiem = date.toFormat('a').toUpperCase();
  const startDate = date.setLocale('en-US').toFormat('t').toUpperCase();
  return startDate.includes(meridiem) ? startDate : `${startDate} ${meridiem}`;
};